import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 3C12.3693 3 12.7086 3.20355 12.8824 3.52941L20.8824 18.5294C21.0477 18.8393 21.0382 19.2133 20.8575 19.5145C20.6768 19.8157 20.3513 20 20 20H4C3.64874 20 3.32323 19.8157 3.14251 19.5145C2.96178 19.2133 2.95235 18.8393 3.11765 18.5294L11.1176 3.52941C11.2914 3.20355 11.6307 3 12 3ZM5.66667 18H18.3333L12 6.125L5.66667 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 10.051C12.4142 10.051 12.75 10.3868 12.75 10.801V13.801C12.75 14.2152 12.4142 14.551 12 14.551C11.5858 14.551 11.25 14.2152 11.25 13.801V10.801C11.25 10.3868 11.5858 10.051 12 10.051Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 16.0137C11.8619 16.0137 11.75 16.1257 11.75 16.2637C11.75 16.4018 11.8619 16.5137 12 16.5137C12.1381 16.5137 12.25 16.4018 12.25 16.2637C12.25 16.1257 12.1381 16.0137 12 16.0137ZM12 17.0137C12.4142 17.0137 12.75 16.6779 12.75 16.2637C12.75 15.8495 12.4142 15.5137 12 15.5137C11.5858 15.5137 11.25 15.8495 11.25 16.2637C11.25 16.6779 11.5858 17.0137 12 17.0137Z",
			fill: "currentColor"
		})
	]
});
export default SvgWarning;
